<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/iam' }">
        <app-i18n code="iam.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="iam.edit.title"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <app-back-button
      route-name="iam"
      :route-params="{ tabName: 'managers' }"
      i18nCode="staff.tabs.managers"
    />

    <h1 class="app-content-title app-content-title--hidden">
      <app-i18n code="iam.edit.title"></app-i18n>
    </h1>

    <div class="app-content-page">
      <div class="app-page-spinner" v-if="findLoading" v-loading="findLoading"></div>
      <el-form
        :label-position="labelPosition"
        :label-width="labelWidthForm"
        :model="model"
        :rules="rules"
        @submit.native.prevent="doSubmit"
        class="form"
        ref="form"
        v-if="model"
      >
        <el-row :gutter="10">
          <!-- Id -->
          <el-col :lg="11" :md="16" :sm="24">
            <el-form-item :label="fields.id.label" :prop="fields.id.name">
              <el-input v-model="model[fields.id.name]" :disabled="true"  />
            </el-form-item>
          </el-col>

          <!-- Email -->
          <el-col :lg="11" :md="16" :sm="24">
            <el-form-item :label="fields.email.label" :prop="fields.email.name">
              <el-tooltip 
                class="item"  
                effect="dark" 
                :content="i18n('user.form.tooltip.emailDisabled')" 
                placement="bottom-start"
              >
                <el-input
                  :disabled="true"
                  prefix-icon="icon-mail"
                  :placeholder="i18n(`user.placeholders.email`)"
                  v-model="model[fields.email.name]"
                />
              </el-tooltip>
            </el-form-item>
          </el-col>

          <!-- First Name -->
          <el-col :lg="11" :md="16" :sm="24">
            <el-form-item
              :label="fields.firstName.label"
              :prop="fields.firstName.name"
              :required="fields.firstName.required"
            >
              <el-input v-model="model[fields.firstName.name]" prefix-icon="icon-player" />
            </el-form-item>
          </el-col>

          <!-- Last Name -->
          <el-col :lg="11" :md="16" :sm="24">
            <el-form-item
              :label="fields.lastName.label"
              :prop="fields.lastName.name"
              :required="fields.lastName.required"
            >
              <el-input v-model="model[fields.lastName.name]" prefix-icon="icon-player"/>
            </el-form-item>
          </el-col>
        
          <!-- Gender -->
          <el-col :lg="11" :md="16" :sm="24">
            <el-form-item
              :label="fields.gender.label"
              :prop="fields.gender.name"
              :required="fields.gender.required"
            >
              <el-select
                :placeholder="i18n('user.placeholders.gender')"
                v-model="model[fields.gender.name]"
              >
                <i slot="prefix" class="icon-family" />
                <el-option
                  :key="option.id"
                  :label="option.label"
                  :value="option.id"
                  v-for="option in fields.gender.options"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <!-- Birthdate -->
          <el-col :lg="11" :md="16" :sm="24">
            <el-form-item
              :label="fields.birthdate.label"
              :prop="fields.birthdate.name"
              :required="fields.birthdate.required"
            >
              <el-date-picker
                type="date"
                :placeholder="i18n('common.date.formatInput')"
                :format="i18n('common.date.formatInput')"
                v-model="model[fields.birthdate.name]"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          
          <!-- PhoneNumber -->
          <el-col :lg="11" :md="16" :sm="24">
            <el-form-item
              :label="fields.phoneNumber.label"
              :prop="fields.phoneNumber.name"
              :required="fields.phoneNumber.required"
            >
              <phone-input v-model="model[fields.phoneNumber.name]" />
            </el-form-item>
          </el-col>

          <!-- Avatars -->
          <el-col :lg="24" :md="24" :sm="24">
            <el-form-item
              :label="fields.avatarsIam.label"
              :prop="fields.avatarsIam.name"
              :required="fields.avatarsIam.required"
            >
              <app-image-upload
                :max="fields.avatarsIam.max"
                :path="fields.avatarsIam.path"
                :schema="fields.avatarsIam.fileSchema"
                v-model="model[fields.avatarsIam.name]"
                :placeholder="i18n('common.uploadFile')"
              ></app-image-upload>
            </el-form-item>
          </el-col>

          <!-- Roles -->
          <el-col :lg="12" :md="12" :sm="24">
            <el-form-item
              :label="fields.roles.label"
              :prop="fields.roles.name"
              :required="fields.roles.required"
            >
              <el-select
                :disabled="disabledRoles"
                multiple
                placeholder
                v-model="model[fields.roles.name]"
              >
                <el-option
                  :key="option.value"
                  :label="option.label"
                  :value="option.value"
                  v-for="option in fields.roles.options"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :lg="24" :md="24" :sm="24">
            <el-form-item>
              <div class="form-buttons">
                <el-button
                  :disabled="saveLoading"
                  @click="doSubmit"
                  type="primary"
                >
                  <app-i18n code="common.save"></app-i18n>
                </el-button>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { FormSchema } from '@shared/form/form-schema';
import { UserModel } from '@modules/auth/user-model';
import { i18n } from '@shared/i18n';

export default {
  name: 'app-iam-edit-page',

  props: ['id'],

  data() {
    return {
      model: null,
    };
  },

  computed: {
    ...mapGetters({
      currentProperty: 'auth/currentProperty',
      labelPosition: 'layout/labelPosition',
      labelWidthForm: 'layout/labelWidthForm',
      record: 'iam/form/record',
      findLoading: 'iam/form/findLoading',
      saveLoading: 'iam/form/saveLoading',
      dateFormat: 'auth/manage/dateFormat',
      timeFormat: 'auth/manage/timeFormat',
    }),

    rules() {
      const { formSchema } = this;
      return formSchema.rules();
    },
    
    formSchema() {
      const { fields } = this;
      return new FormSchema([
        fields.id,
        fields.email,
        fields.firstName,
        fields.lastName,
        fields.gender,
        fields.birthdate,
        fields.phoneNumber,
        fields.avatarsIam,
        fields.roles,
      ]);
    },

    fields() {
      const { dateFormat, timeFormat} = this;
      return new UserModel({
        dateFormat, timeFormat
      }).fields();
    },
    disabledRoles() {
      return true ; //_.contains(this.model.roles, 'admin') ;
    },
  },

  async created() {
    const { formSchema } = this;
    await this.doFind(this.id);
    this.model = formSchema.initialValues(this.record);
  },

  methods: {
    ...mapActions({
      doFind: 'iam/form/doFind',
      doUpdate: 'iam/form/doUpdate',
    }),

    doReset() {
      const { formSchema } = this;
      this.model = formSchema.initialValues(this.record);
    },

    async doSubmit() {
      const { formSchema } = this;
      try {
        await this.$refs.form.validate();
      } catch (error) {
        return;
      }
      const values = formSchema.cast(this.model);
      delete values.email;
      this.doUpdate({ values });
    },

    i18n(code) {
      return i18n(code);
    },
  },
};
</script>
